export const GetGradeColour = (idwalGrade?: number) => {
    let scoreColor = "white";
    let fillColor;

    if (!idwalGrade) {
        return ["", "#E7ECF0"];
    }

    if (idwalGrade >= 90) {
        fillColor = "#53A440";
    } else if (idwalGrade >= 70) {
        scoreColor = "#333333";
        fillColor = "#C0E005";
    } else if (idwalGrade >= 50) {
        fillColor = "#F8A111";
    } else if (idwalGrade >= 30) {
        fillColor = "#EF5A14";
    } else {
        fillColor = "#EC1E17";
    }

    return [scoreColor, fillColor];
};
